import React from 'react'
import Modal from 'react-modal'
import modalStyle from '../../../_common/core/modalStyle'

import CustomFieldsForm from './CustomFieldsForm'

const CustomFieldModal = props => {
  const { isOpen, fieldData, customFieldsData, onSubmit, onClose } = props

  return (
    <Modal
      className="modal-dialog modal-trans"
      style={modalStyle}
      isOpen={isOpen}
      contentLabel="Modal"
      onRequestClose={onClose}
      closeTimeoutMS={150}
      ariaHideApp={false}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div>
            <div className="modal-header">
              <p className="h4 text-compact">Create Custom Field</p>
            </div>
            <div className="modal-body" style={{ padding: 25 }}>
              <CustomFieldsForm
                fieldData={fieldData}
                customFieldsData={customFieldsData}
                onSubmit={onSubmit}
                onClose={onClose}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CustomFieldModal
